class ShowMore {
  constructor() {
    // Prevent multiple instances
    if (window.ShowMoreInstance) {
      return window.ShowMoreInstance;
    }
    window.ShowMoreInstance = this;
    this.init();
  }

  init() {
    const productGrids = document.querySelectorAll('.product-grid');
    productGrids.forEach(grid => {
      const products = grid.querySelectorAll('.grid__item');
      const mobileThreshold = parseInt(grid.dataset.mobileThreshold) || 4;
      const desktopThreshold = parseInt(grid.dataset.desktopThreshold) || 8;
      
      // Hide products beyond threshold initially
      products.forEach((product, index) => {
        if (window.innerWidth < 750) {
          if (index >= mobileThreshold) {
            product.style.display = 'none';
          }
        } else {
          if (index >= desktopThreshold) {
            product.style.display = 'none';
          }
        }
      });

      // Create and append show more button if needed
      if (products.length > (window.innerWidth < 750 ? mobileThreshold : desktopThreshold)) {
        const showMoreButton = document.createElement('button');
        showMoreButton.className = 'show-more-button button';
        showMoreButton.textContent = 'Show More';
        showMoreButton.setAttribute('data-expanded', 'false');
        showMoreButton.addEventListener('click', () => this.handleShowMore(products, showMoreButton, grid));
        grid.parentNode.appendChild(showMoreButton);
      }
    });

    // Handle window resize
    window.addEventListener('resize', () => {
      productGrids.forEach(grid => {
        const products = grid.querySelectorAll('.grid__item');
        const mobileThreshold = parseInt(grid.dataset.mobileThreshold) || 4;
        const desktopThreshold = parseInt(grid.dataset.desktopThreshold) || 8;
        const threshold = window.innerWidth < 750 ? mobileThreshold : desktopThreshold;
        const showMoreButton = grid.parentNode.querySelector('.show-more-button');
        const expanded = showMoreButton && showMoreButton.getAttribute('data-expanded') === 'true';
        if (expanded) {
          // If expanded, show all products and set button to 'Show Less'
          products.forEach(product => {
            product.style.display = '';
          });
          if (showMoreButton) {
            showMoreButton.textContent = 'Show Less';
            showMoreButton.setAttribute('data-expanded', 'true');
            showMoreButton.style.display = products.length > threshold ? '' : 'none';
          }
        } else {
          // If not expanded, collapse to threshold
          products.forEach((product, index) => {
            if (index < threshold) {
              product.style.display = '';
            } else {
              product.style.display = 'none';
            }
          });
          if (showMoreButton) {
            showMoreButton.textContent = 'Show More';
            showMoreButton.setAttribute('data-expanded', 'false');
            showMoreButton.style.display = products.length > threshold ? '' : 'none';
          }
        }
      });
    });
  }

  handleShowMore(products, button, grid) {
    const isMobile = window.innerWidth < 750;
    const threshold = isMobile ? 
      parseInt(products[0].closest('.product-grid').dataset.mobileThreshold) || 4 :
      parseInt(products[0].closest('.product-grid').dataset.desktopThreshold) || 8;
    // Check if currently expanded
    const expanded = button.getAttribute('data-expanded') === 'true';
    if (!expanded) {
      // Show all products
      products.forEach(product => {
        product.style.display = '';
      });
      button.textContent = 'Show Less';
      button.setAttribute('data-expanded', 'true');
      grid.setAttribute('data-show-more-expanded', 'true');
    } else {
      // Collapse to threshold
      products.forEach((product, index) => {
        if (index < threshold) {
          product.style.display = '';
        } else {
          product.style.display = 'none';
        }
      });
      button.textContent = 'Show More';
      button.setAttribute('data-expanded', 'false');
      grid.setAttribute('data-show-more-expanded', 'false');
    }
  }
}

// Only define custom element if not already defined
if (!customElements.get('show-more')) {
  customElements.define('show-more', class extends HTMLElement {
    connectedCallback() {
      new ShowMore();
    }
  });
}

// Initialize only once when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    if (!window.ShowMoreInstance) {
      new ShowMore();
    }
  });
} else {
  if (!window.ShowMoreInstance) {
    new ShowMore();
  }
}
